import { Injectable } from '@angular/core';

export interface InviteFormResult {
  emails: string[];
}

@Injectable()
export abstract class InviteFormStrategy {
  abstract readonly header: string;
  abstract readonly description: string;
  abstract readonly emailPlaceholder: string;
  abstract readonly inviteButtonLabel: string;
  abstract readonly cancelButtonLabel: string;
}
